// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Mongolia from '../_raw/flag/icon_flag_mongolia.png';

export default () => <img src={Mongolia} alt="Mongolia" />;
